module.exports = __webpack_public_path__ + "static/media/4.807c7597.png";